// extracted by mini-css-extract-plugin
module.exports = {"citationStyle":"citation-output-style_citationStyle__2m25e","downArrowContainer":"citation-output-style_downArrowContainer__bim5n"};